export enum ModelTypeEnum {
  MIC_713_OXB1 = 'MIC-713 OXB1',
  MIC_713_OXB2 = 'MIC-713 OXB2',
}

export interface EdgeDevice {
  uuid: string;
  serialNumber: string;
  modelType: ModelTypeEnum;
  internalNotes: string | null;
  name: string;
  createdAt: string;
}

export interface NewEdgeDevice {
  name: string;
  serialNumber: string;
  modelType: ModelTypeEnum;
  internalNotes?: string | null;
}

export const EMPTY_NEW_EDGE_DEVICE: NewEdgeDevice = {
  name: '',
  serialNumber: '',
  modelType: ModelTypeEnum.MIC_713_OXB1,
};
